import type { IRankTrackerWidgetData } from "../types";

import { RightAsideDefault } from "./RightAside/Default";
import { RightAsideEmpty } from "./RightAside/Empty";
import { RightAsideLoading } from "./RightAside/Loading";

type RankTrackerRightAsideProps = {
    data?: IRankTrackerWidgetData | null;
    isEmpty?: boolean;
    isLoading?: boolean;
};

export const RankTrackerRightAside = ({ data, isEmpty, isLoading }: RankTrackerRightAsideProps) => {
    if (isLoading) {
        return <RightAsideLoading />;
    }

    if (isEmpty || !data) {
        return <RightAsideEmpty />;
    }

    return <RightAsideDefault data={data} />;
};
